import { inject, observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useAudioRecorder } from 'react-audio-voice-recorder';

const ChatTool = inject('store')(
  observer(({ store }) => {
    const {
      startRecording,
      stopRecording,
      recordingBlob,
      isRecording,
      recordingTime,
    } = useAudioRecorder();

    useEffect(() => {
      if (!recordingBlob) return;

      // eslint-disable-next-line no-console
      console.log(recordingBlob);

      getAudio(recordingBlob);
    }, [recordingBlob]);

    const [text, setText] = useState('---');

    const getAudio = async (blob) => {
      setText('---');
      const data = new FormData();
      data.append('file', blob, '2260c8a3-5c42-4a1b-8503-dedd931cc835.webm');
      try {
        await store.api.post('/auth/whisper', data, {}).then(({ data }) => {
          setText(data.text);
        });
      } catch (error) {
        console.error(error);
      }
    };

    return (
      <div className="font-figtree">
        <h1>---{'>'} Start</h1>
        <div className="ml-20">
          <br />
          <br />
          <br />
          <button
            className="bg-nue-blue hover:bg-nue-blue/70 text-white font-bold py-2 px-4 border rounded"
            onClick={() => {
              startRecording();
              setText('---');
            }}
          >
            Start recording
          </button>
          <br />
          {isRecording ? 'REC' : 'NO'}
          <br />
          {recordingTime}s
          <br />
          <button
            className="bg-lavender hover:bg-lavender/70 text-violet-blue font-bold py-2 px-4 border rounded"
            onClick={stopRecording}
          >
            Stop recording
          </button>
          <br />
          <br />
          <br />
          <br />
          <br />
          <p>{text}</p>
          <br />
          <br />
        </div>
        <h1>---&gt; End</h1>
      </div>
    );
  })
);

export default ChatTool;
